<template>
  <div class="components-layout">
    <div class="nav-intruduce">
      <span>总长者数 | {{ elderNum || 0 }}</span>
    </div>
    <div class="charts">
      <EchartsLayout :option="option"></EchartsLayout>
    </div>
  </div>
</template>

<script>
import { getCacheOrRequest } from "@/utils/index.js";
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  mixins: [ComponentBase],
  components: {
    EchartsLayout,
  },
  data() {
    return {
      option: null,
      elderNum: 0,
    };
  },
  methods: {
    get_component_data() {
      getCacheOrRequest.call(this, {
        method: "get",
        url: `/nh/getElderNumList?type=age`,
        success: (response) => {
          let indicatorArr = [],
            valueArr = [],
            max = 0;
          response.data &&
            response.data.data &&
            response.data.data.elderList &&
            response.data.data.elderList.map &&
            response.data.data.elderList.map((item) => {
              if (item.number > max) {
                max = item.number;
              }
              indicatorArr.push({ name: item.age });
              valueArr.push(item.number);
            });

          // 设置边界值
          indicatorArr = this.setAndicatorArrMax(indicatorArr, max);

          // 去除岁的中文
          indicatorArr.map((item) => {
            item.name = item.name.replace(/岁/, "");
            return item;
          });

          // 总长者数
          this.elderNum = response.data.data.allNum || 0;

          // 更新配置
          this.option = {
            radar: {
              radius: "65%",
              axisLine: { lineStyle: { color: "rgba(238,238,238, 0.2)" } },
              shape: "polygon",
              splitArea: { areaStyle: { color: "transparent" } },
              splitLine: {
                lineStyle: {
                  color: new Array(6).fill("#6b6b6b"),
                  width: 1,
                },
              },
              name: { textStyle: { color: "#ffffff" } },
              indicator: [...indicatorArr],
            },
            textStyle: { fontWeight: "bold", fontSize: 40 },
            series: [
              {
                areaStyle: { normal: { color: "transparent" } },
                itemStyle: {
                  normal: { borderColor: "rgba(87,201,255,0.2)", borderWidth: 12 },
                },
                lineStyle: { normal: { width: 5 } },
                symbol: "circle",
                type: "radar",
                data: [{ value: [...valueArr], name: "总长者数" }],
              },
            ],
            tooltip: { textStyle: { fontSize: 54 } },
            polar: { radius: "75%", center: ["50%", "50%"] },
            angleAxis: {
              type: "category",
              clockwise: false,
              boundaryGap: false,
              splitLine: { show: false },
              axisLine: { show: false },
            },
            radiusAxis: {
              type: "value",
              max: 100,
              splitLine: { show: false },
              axisTick: { show: false },
              axisLabel: { show: false },
            },
          };
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.components-layout {
  flex-direction: column;
  .charts {
    width: 100%;
    height: calc(~"100% - 120px");
  }
}
</style>
